import { render, staticRenderFns } from "./UserContractButton.vue?vue&type=template&id=54fb1ecc"
import script from "./UserContractButton.vue?vue&type=script&lang=js"
export * from "./UserContractButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports